import React from "react"
import { injectIntl } from "gatsby-plugin-intl"

const ContactInfo = ( { intl } ) => (
  [
    <h2 key="email" className="email hidden"><a href={ "mailto:" + intl.formatMessage( { id: "contact.email" } )}>{ intl.formatMessage( { id: "contact.email" } ) }</a></h2>,
    <span key="tel" className="tel hidden">+55 11 3071 3810</span>,
    <address key="address" className="address hidden">
      <span className="street hidden">{ intl.formatMessage( { id: "contact.address.street" } ) }</span>
      <span className="city hidden">{ intl.formatMessage( { id: "contact.address.city" } ) }</span>
      <span className="zip hidden">{ intl.formatMessage( { id: "contact.address.zip" } ) }</span>
    </address>,
    <div key="social" className="social-links">
      <a className="hidden" href="https://www.facebook.com/TryConsultoria" target="_blank" rel="noopener noreferrer">Facebook</a>
      <a className="hidden" href="https://www.linkedin.com/company/try-consultoria-e-pesquisas" target="_blank" rel="noopener noreferrer">LinkedIn</a>
      <a className="hidden" href="https://instagram.com/try.consultoria/" target="_blank" rel="noopener noreferrer">Instagram</a>
    </div>
  ]
)

const injected = injectIntl( ContactInfo )
export { injected as ContactInfo }
